import React, {memo, useCallback, useEffect, useState} from 'react';
import { useLocation } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {actions} from "../../models/stores/actions";
import styles from './Index.module.scss';
import {routers} from "../../routers";
import { isMath, backTo, getOuterHeight, isNormalZhEnCss } from '../../utils'
import localesToggleW from '../../assets/img/public/icons/localesToggleW.svg';
import localesToggleG from '../../assets/img/public/icons/localesToggleG.svg';


const Locales = memo((props) => {
    const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
    const {lang} = useSelector(({localesReducer}) => localesReducer);
    const dispatch = useDispatch();
    const { localesI18n } = actions;

    // 

    // 获取 History
    let location = useLocation();
    const [isShow, setIsShow] = useState(false);
    const [langName, setLangName] = useState('LN');

    // 语言切换
    const handleLocales = useCallback((lang) => {
        if(lang === 'zhCN'){
            localStorage.setItem('lang', lang);
            const langType = localStorage.getItem('lang');
            dispatch(localesI18n({lang: langType}));
            setIsShow(false);
            setLangName('CN');
        }else{
            localStorage.setItem('lang', lang);
            const langType = localStorage.getItem('lang');
            dispatch(localesI18n({lang: langType}));
            setIsShow(false);
            setLangName('EN');
        }

    }, [dispatch, localesI18n]);

    useEffect(() => {
        document.onclick = handleOtherEvent;
        // 设置BOM浏览器的标题
        const pathName = routers.filter(item => item.path === location.pathname)[0];
        window.document.title = lang === 'English' ? pathName.nameEN : pathName.nameZH;
    }, [dispatch, lang, localesI18n, location.pathname, props]);



    const scrollEvent = (type) => {
        window[type]('scroll', () => {
            setIsShow(false);
        }, false);
    }

    useEffect(() => {
        scrollEvent('addEventListener');
        /* return () => {
            scrollEvent('removeEventListener');
        } */
    }, [isShow]);


    

    const isNormal = recReSizeReducer <= 750 ? styles.normalH5 : styles.normal;

    const localesToggleIcon = () => {
        const {
            icons, // 图标
            path, // 路径
            screenTop, // 顶部的值
        } = props.config;
        const scrollIcon = path ? (screenTop ? icons[1] :  icons[0]): icons[1];
        const isIcon = recReSizeReducer <= 750 ? icons[1] : scrollIcon;
        return isIcon;
    }

    const langCss = () => {
        const {
            path, // 路径
            screenTop, // 顶部的值
        } = props.config;

        const isTextName = path ? (screenTop ? 'textBaseCEG' : 'textBaseCE'): 'textBaseCEG';
        return recReSizeReducer <= 750 ? 'textBaseCEG' : isTextName;
    }

    const localesLnCss = () => {
        const {
            path, // 路径
            screenTop, // 顶部的值
        } = props.config;

        const isTextName = path ? (screenTop ? 'localesLnG' : 'localesLn'): 'localesLnG';
        return recReSizeReducer <= 750 ? 'localesLnG' : isTextName;
    }

    

    const desktopMobile = () => {
        const num = langName ===  'EN' ? 145 : 45;
        const isMarginLeft =  recReSizeReducer <= 750 ? {marginLeft: isMath(recReSizeReducer, num)} : null;
        return (
            <div className={isNormal} style={isMarginLeft}>
                <div className="defaultLN" onClick={(event) => handleDefaultLN(event)}>
                    <span className={localesLnCss()}>{langName}</span>
                    <i className="localesToggle"><img className="localesToggleSvg" src={localesToggleIcon()} alt=""/></i>
                </div>

                {isShow ? (
                    <div className={langCss()}>
                        <span onClick={() => handleLocales('zhCN')} className={lang ===  'zhCN' ? 'zhCN' : 'zhCN langActive'}>CN</span>
                        <span onClick={() => handleLocales('enUS')} className={lang ===  'enUS' ? 'enUS' : 'enUS langActive'}>EN</span>
                    </div>
                ) : null}
            </div>
        );
    };

    // 他不光阻止冒泡，还能阻止在当前事件触发元素上，触发其它事件。这样即使你都绑定到document上也阻止不了我了吧。
    const handleOtherEvent = () => {
        setIsShow(false);
    }
    const handleDefaultLN = (event) => {
        event.nativeEvent.stopImmediatePropagation();
        setIsShow(!isShow);
    }

    return desktopMobile();

});


export default Locales;